<template>
  <div class="ticket-form-details">
    <h3>{{ "اطلاعات تیکت" }}</h3>
    <vs-row>
      <vs-col vs-w="6" vs-xs="12">
        <p class="mb-1">{{ "نام ثبت کننده" }}</p>
        <vs-input v-model="username" :disabled="true" class="w-100 mt-1" />
      </vs-col>
      <vs-col vs-w="6" vs-xs="12">
        <p class="mb-1">{{ "انتخاب بخش" }}</p>
        <vs-select v-model="selectedDepartment" width="100%">
          <vs-select-item
            v-for="(department, index) of departments"
            :text="`${index + 1} - ${department.name}`"
            :key="department.id"
            :value="department"
          />
        </vs-select>
      </vs-col>
      <vs-col vs-w="6" vs-xs="12">
        <p class="mb-1">{{ "اولیت ارسال" }}</p>
        <vs-select v-model="selectedPriority" width="100%">
          <vs-select-item
            v-for="(priority, index) of priorities"
            :text="`${index + 1} - ${priority.name}`"
            :key="priority.id"
            :value="priority"
          />
        </vs-select>
      </vs-col>
    </vs-row>
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";

export default {
  name: "FormDetails.vue",
  components: {},
  data() {
    return {
      username: "",
      selectedPriority: false,
      selectedDepartment: false,
      departments: [
        { id: "technical", name: "پشتیبانی فنی" },
        { id: "financial", name: "امور مالی و حسابداری" },
        { id: "supervision", name: "واحد نظارت و اطلاع رسانی" },
      ],
      priorities: [
        { id: "high", name: "زیاد" },
        { id: "medium", name: "متوسط" },
        { id: "low", name: "کم" },
      ],
    };
  },
  computed: {
    ...mapGetters({
      currentProvider: "profile/currentProvider",
    }),
    ...mapState({
      myProfile: (state) => state.profile.myProfile.data,
    }),
  },
  mounted() {
    this.username = this.myProfile.name;
  },
  methods: {
    getData() {
      return {
        username: this.username,
        priority: this.selectedPriority,
        department: this.selectedDepartment,
      };
    },
  },
};
</script>

<style lang="scss">
.ticket-form-details {
  flex: 1;

  h3 {
    margin-bottom: 20px;
  }
}
</style>

